module.exports = __webpack_public_path__ + "static/media/ppk.a3bb98b2.jpeg";